export const formTypes = {
    none: "",
    integer: "ЧИСЛО",
    string: "СТРОКА",
    natural_number: "НАТУРАЛЬНОЕ ЧИСЛО",
    date: "ДАТА",
    text: "ТЕКСТ",
    file: "ФАЙЛ",
    list: "СПИСОК",
    phone: "ТЕЛЕФОН",
    email: "ПОЧТА",
    country_city: "СТРАНА",
    photo: "ФОТО"
}

export const fieldTypeSelectOptions = [
    { value: 'integer', label: 'ЧИСЛО' },
    { value: 'string', label: 'СТРОКА' },
    { value: 'natural_number', label: 'НАТУРАЛЬНОЕ ЧИСЛО' },
    { value: 'date', label: 'ДАТА' },
    { value: 'text', label: 'ТЕКСТ' },
    { value: 'file', label: 'ФАЙЛ' },
    { value: 'photo', label: 'ФОТО' },
    { value: 'phone', label: 'ТЕЛЕФОН' },
    { value: 'email', label: 'EMAIL' },
]

export const extensionSelectOptions = [
    {
        label: '.jpg',
        value: '.jpg'

    },
    {
        label: '.jpeg',
        value: '.jpeg'
    },
    {
        label: '.png',
        value: '.png'
    },
    {
        label: '.pdf',
        value: '.pdf'
    },
    {
        label: '.webp',
        value: '.webp',
    },
    {
        label: '.zip',
        value: '.zip',
    },
    {
        label: '.rar',
        value: '.rar',
    },
    {
        label: '.7z',
        value: '.7z',
    },
    {
        label: '.xlsx',
        value: '.xlsx',
    },
    {
        label: '.xls',
        value: '.xls',
    },
    {
        label: '.doc',
        value: '.doc',
    },
    {
        label: '.docx',
        value: '.docx'
    }
]